import { makeStyles } from '@mui/styles';
const checkboxesStyles = makeStyles(({ breakpoints }) => ({
    root: {
        display: 'flex',
        [breakpoints.down(breakpoints.values.sm)]: {
            flexDirection: 'column',
        },
    },
    itemRoot: {
        paddingRight: 0,
    },
    item: {
        paddingRight: 15,
    },
}), { name: 'Common_Checkboxes' });
export default checkboxesStyles;
//# sourceMappingURL=checkboxes.styles.js.map